import { render, staticRenderFns } from "./AwardListComponent.vue?vue&type=template&id=0698b1d6&scoped=true"
import script from "./AwardListComponent.vue?vue&type=script&lang=js"
export * from "./AwardListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0698b1d6",
  null
  
)

export default component.exports